<template lang="pug">
.container-fluid(style="padding-bottom:40px;")
	.mb-2(v-if="seccion === 'listado'")
		.card
			.card-header.bg-primary.text-white(style="cursor:pointer;" @click="verFiltros = !verFiltros")
				span.fa.fa-filter.mr-2
				| Filtros
				button.close(style="color:white;opacity:1;", v-if="!filtro.locutor && !filtro.agente && !filtro.anunciante && !filtro.tipo")
					span(:class="(verFiltros) ? 'fa fa-caret-up' : 'fa fa-caret-down'")
			.card-body(v-if="verFiltros")
				.row
					.col-xs-12.col-sm-12.col-md-6.col-lg-3.col-xl-3
						.form-group
							label Locutor/a
							input.form-control(placeholder="Filtra por locutor", v-model="filtro.locutor")
					.col-xs-12.col-sm-12.col-md-6.col-lg-3.col-xl-3
						.form-group
							label Anunciante
							input.form-control(placeholder="Filtra por anunciante", v-model="filtro.anunciante")
					.col-xs-12.col-sm-12.col-md-6.col-lg-3.col-xl-3
						.form-group
							label Agente
							input.form-control(placeholder="Filtra por agente", v-model="filtro.agente")
					.col-xs-12.col-sm-12.col-md-6.col-lg-3.col-xl-3
						.form-group
							label Tipo
							br
							.btn-group
								button.btn(:class="(filtro.tipo === null) ? 'btn-primary' : ''", @click="filtro.tipo = null") Todas
								button.btn(:class="(filtro.tipo === 'propias') ? 'btn-primary' : ''", @click="filtro.tipo = 'propias'") Propias
								button.btn(:class="(filtro.tipo === 'externas') ? 'btn-primary' : ''", @click="filtro.tipo = 'externas'") Externas
				.alert.alert-danger(v-if="filtro.locutor || filtro.agente || filtro.anunciante || filtro.tipo")
					span.fa.fa-exclamation-triangle.mr-2
					| Se están filtrando los resultados
	.row.text-left(v-if="seccion === 'listado'")
		fase-tareas(v-for="fase in fases", :key="fase.id", :titulo="fase.titulo", :listado="fase.tareas", :clase="fase.clase", @abrir="cargaOrden($event)")
	buscador(v-show="seccion == 'buscador'", @abrir="cargaOrden($event)")
	nueva-orden(v-show="seccion == 'nueva'", :principal="true", @actualizar="getTareas()", @cerrar="seccion = seccionAnterior")
	vista-tarea(@actualizar="getTareas()", v-for="tarea in listadoAbiertos", :key="tarea.ID_tarea", :idtarea="tarea.ID_tarea", @cerrar="cerrarTarea(tarea.ID_tarea)", :focoactivo="(seccion === 'tarea' && ID_tarea === tarea.ID_tarea)", v-show="(seccion === 'tarea' && ID_tarea === tarea.ID_tarea)")
	estadisticas(v-show="seccion === 'estadisticas'")
	.barraInferior(v-if="listadoAbiertos.length > 0")
		ul
			li(:class="{ activo : (seccion === 'tarea' && ID_tarea === tarea.ID_tarea)}", v-for="tarea in listadoAbiertos", :key="tarea.ID_tarea", @click="maximizar(tarea.ID_tarea)")
				span.fa-w.fa.fa-volume-up(style="margin-right:5px;")
				| {{ tarea.nombre }}
</template>

<script>
/**
 * FASES DEL PROCESO DE PRODUCCIÓN:
 * 	- pteIdea
 * 	- pteApruebaIdea
 *	- pteProduccion
 *	- pteAprobar
 */

import VistaTarea from './../produccion/produccion'
import Buscador from './../buscador/buscador'
import FaseTareas from './../produccion/fase-tareas-new'
import Estadisticas from '../estadisticas/estadisticas'
import Nueva from '../nueva/nueva'
import API from '../../services/api'
import { mapMutations, mapGetters } from 'vuex'
export default {
	name: 'Listado',
	components: {
		'estadisticas': Estadisticas,
		'vista-tarea': VistaTarea,
		'fase-tareas': FaseTareas,
		'buscador': Buscador,
		'nueva-orden': Nueva
	},
	data: function () {
		return {
			filtro: {
				fases: [],
				locutor: null,
				agente: null,
				anunciante: null,
				tipo: null
			},
			verFiltros: false,
			tareas: [],
			seccion: 'listado',
			seccionAnterior: 'listado',
			ID_tarea: null,
			listadoAbiertos: [],
			/* fasesB: [
				{
					id: 'pteIdea',
					titulo: 'Pdte. de idea creativa',
					tareas: []
				},
				{
					id: 'pteAprobarTexto',
					titulo: 'Pdte. de aprobar idea',
					tareas: []
				},
				{
					id: 'pteProduccion',
					titulo: 'Pdte. de producción',
					tareas: []
				},
				{
					id: 'pteAprobarProduccion',
					titulo: 'Pdte. de aprobar producción',
					tareas: []
				}
			], */
			intervalo: null
		}
	},

	watch: {
		'$route.params': function (newVal) {
			if (newVal.seccion === 'tarea' && newVal.TareaID) {
				API.getTarea(newVal.TareaID)
					.then(res => {
						this.cargaOrden(res.data.tarea)
					})
					.catch(e => {
						console.error(e)
						this.$responseError(e)
					})
			} else if (newVal.seccion === 'listado') {
				this.seccion = 'listado'
			} else if (newVal.seccion === 'buscador') {
				this.seccion = 'buscador'
			} else if (newVal.seccion === 'nueva') {
				this.seccion = 'nueva'
			} else if (newVal.seccion === 'estadisticas') {
				this.seccion = 'estadisticas'
			}
		}
	},

	created () {
		this.getTareas()
		this.intervalo = window.setInterval(() => this.getTareas(), 5000)

		const menu = [
			{
				'icono': 'fa fa-plus-circle',
				'nombre': 'Nueva',
				activo: false,
				'callback': (a) => {
					this.setMenuActivo(a)
					this.$router.push('/main/produccion/nueva')
					// this.seccion = 'nueva'
				}
			},
			{
				'icono': 'fa fa-list',
				'nombre': 'Listado',
				activo: true,
				callback: (a) => {
					this.setMenuActivo(a)
					this.$router.push('/main/produccion/listado')
					// this.seccion = 'listado'
				}
			},
			{
				'icono': 'fa fa-search',
				'nombre': 'Buscador',
				activo: false,
				callback: (a) => {
					this.setMenuActivo(a)
					this.$router.push('/main/produccion/buscador')
					// this.seccion = 'buscador'
				}
			}]

		if (this.permisos.producciones_verEstadisticas) {
			menu.push(
				{
					'icono': 'fa fa-line-chart',
					'nombre': 'Estadíst...',
					activo: false,
					callback: (a) => {
						this.setMenuActivo(a)
						this.$router.push('/main/produccion/estadisticas')
						// this.seccion = 'estadisticas'
					}
				}
			)
		}

		this.setMenu(menu)

		const params = this.$route.params
		if (params.seccion === 'tarea' && params.TareaID) {
			API.getTarea(params.TareaID)
				.then(res => {
					this.cargaOrden(res.data.tarea)
				})
				.catch(e => {
					console.error(e)
					this.$responseError(e)
				})
		} else if (params.seccion === 'listado') {
			this.seccion = 'listado'
		} else if (params.seccion === 'buscador') {
			this.seccion = 'buscador'
		} else if (params.seccion === 'nueva') {
			this.seccion = 'nueva'
		} else if (params.seccion === 'estadisticas') {
			this.seccion = 'estadisticas'
		}
	},

	beforeDestroy () {
		window.clearInterval(this.intervalo)
	},

	computed: {
		...mapGetters({
			permisos: 'permisos/permisos',
			usuario: 'session/usuario'
		}),
		fases () {
			let fases = [
				{
					id: 'pteIdea',
					titulo: 'Pdte. de idea creativa',
					tareas: [],
					clase: 'bg-warning'
				},
				{
					id: 'pteAprobarIdea',
					titulo: 'Pdte. de aprobar idea',
					tareas: [],
					clase: 'bg-danger'
				},
				{
					id: 'pteProduccion',
					titulo: 'Pdte. de producción',
					tareas: [],
					clase: 'bg-info'
				},
				{
					id: 'pteAprobarProduccion',
					titulo: 'Pdte. de aprobar producción',
					tareas: [],
					clase: 'bg-success'
				}
			]

			// Recorremos las tareas para clasificarlas
			for (let i = 0; i < this.tareas.length; i++) {
				const tarea = this.tareas[i]
				if (this.filtro.locutor) {
					const exp = new RegExp(this.filtro.locutor, 'ig')
					let encontrado = false
					for (let loc in tarea.locutores) {
						if (tarea.locutores[loc].LocutorNombre.match(exp)) {
							encontrado = true
						}
					}

					if (!encontrado) {
						continue
					}
				}

				if (this.filtro.agente) {
					const exp = new RegExp(this.filtro.agente, 'ig')
					let encontrado = false
					if (tarea.agenteNombre.match(exp)) {
						encontrado = true
					}

					if (!encontrado) {
						continue
					}
				}

				if (this.filtro.anunciante) {
					const exp = new RegExp(this.filtro.anunciante, 'ig')
					let encontrado = false
					if (tarea.anuncianteNombre.match(exp)) {
						encontrado = true
					}

					if (!encontrado) {
						continue
					}
				}

				if (this.filtro.tipo) {
					if (this.filtro.tipo === 'propias' && tarea.externa === 1) {
						continue
					} else if (this.filtro.tipo === 'externas' && tarea.externa === 0) {
						continue
					}
				}
				for (let f = 0; f < fases.length; f++) {
					if (fases[f].id === tarea.fase) {
						fases[f].tareas.push(tarea)
					}
				}
			}

			return fases
		},

		listadoPteIdea () {
			const lista = []

			for (let i = 0; i < this.tareas.length; i++) {
				if (this.tareas[i].fase === 'pteIdea') {
					lista.push(this.tareas[i])
				}
			}

			return lista
		},

		listadoPteAprobarIdea () {
			const lista = []

			for (let i = 0; i < this.tareas.length; i++) {
				if (this.tareas[i].fase === 'pteAprobarIdea') {
					lista.push(this.tareas[i])
				}
			}

			return lista
		},

		listadoPteProduccion () {
			const lista = []

			for (let i = 0; i < this.tareas.length; i++) {
				if (this.tareas[i].fase === 'pteProduccion') {
					lista.push(this.tareas[i])
				}
			}

			return lista
		},

		listadoPteAprobar () {
			const lista = []

			for (let i = 0; i < this.tareas.length; i++) {
				if (this.tareas[i].fase === 'pteAprobar') {
					lista.push(this.tareas[i])
				}
			}

			return lista
		}
	},

	methods: {
		...mapMutations({
			setMenu: 'top/setMenu',
			setMenuActivo: 'top/setMenuActivo'
		}),
		getTareas () {
			// Vamos a obtener el listado de tareas
			API.getListadoTareas('get-listado-tareas.php')
				.then(res => {
					this.tareas = res.data.tareas
				})
				.catch(e => {
					console.error(e)
				})
		},

		esFaseActiva (fase) {
			return this.filtro.fases.indexOf(fase) >= 0
		},

		activaFase (fase) {
			const ind = this.filtro.fases.indexOf(fase)
			if (ind < 0) {
				this.filtro.fases.push(fase)
			} else {
				this.filtro.fases.splice(ind, 1)
			}
		},

		cargaOrden (datos) {
			console.log(datos)
			// Comprobamos si está ya añadida
			for (let i = 0; i < this.listadoAbiertos.length; i++) {
				if (this.listadoAbiertos[i].ID_tarea === datos.ID_tarea) {
					this.maximizar(datos.ID_tarea)
					return
				}
			}

			datos.titulo = datos.titulo || 'Sin título'

			this.listadoAbiertos.push({
				ID_tarea: datos.ID_tarea,
				nombre: datos.titulo
			})

			this.maximizar(datos.ID_tarea)

			this.setMenuActivo({})
		},

		cerrarTarea (idTarea) {
			let cerrado = false
			for (let i = this.listadoAbiertos.length - 1; i >= 0; i--) {
				if (cerrado === true) {
					this.maximizar(this.listadoAbiertos[i].ID_tarea)
					return
				}
				if (this.listadoAbiertos[i].ID_tarea === idTarea) {
					this.listadoAbiertos.splice(i, 1)
					cerrado = true
				}
			}

			// Si llegamos aquí es porque no queda nada abierto
			if (this.seccion === 'tarea' && this.ID_tarea === idTarea) {
				this.seccion = this.seccionAnterior
			}
		},

		maximizar (idTarea) {
			this.$router.push('/main/produccion/tarea/' + idTarea)
			this.seccionAnterior = this.seccion
			this.seccion = 'tarea'
			this.ID_tarea = idTarea
		}
	}
}
</script>

<style scoped>
	div.barraInferior {
		position: fixed;
		display: block;
		bottom: 0;
		left: 0;
		right: 0;
		padding: 1px;
		background-color: darkgrey;
		text-align: left;
		box-shadow: 0 2px 15px rgba(0,0,0,0.3);
	}

	div.barraInferior > ul {
		position: relative;
		display: block;
		margin: 0;
		padding: 0;
	}

	div.barraInferior > ul > li {
		position: relative;
		display: inline-block;

		background-color: rgba(0,0,0,0.2);
		color: white;
		padding: 4px;
		padding-left: 15px;
		padding-right:15px;
		margin-right: 1px;
		margin-left: 0;

		border: 1px solid rgba(0,0,0,0.2);
		border-radius: 1px;

		cursor: pointer;
		font-weight: bold;
	}

	div.barraInferior > ul > li:hover {
		background-color: rgba(0,0,0,0.4);
	}

	div.barraInferior > ul > li.activo {
		background-color: rgba(0,0,0,0.6);
	}
</style>



// WEBPACK FOOTER //
// src/modulos/produccion/vue/components/listado-fases/listado.vue